import { render, staticRenderFns } from "./attach.vue?vue&type=template&id=241e9422&"
import script from "./attach.vue?vue&type=script&lang=ts&"
export * from "./attach.vue?vue&type=script&lang=ts&"
import style0 from "./attach.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports